var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkhackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236 555 c-116 -41 -178 -188 -127 -300 23 -52 91 -112 135 -120 56 -11 137 18 185 66 79 79 90 194 28 286 -52 78 -128 101 -221 68z m50 -101 c-3 -8 -1 -24 4 -35 9 -16 7 -19 -14 -19 -13 0 -30 -2 -38 -5 -9 -4 -13 5 -14 29 0 30 3 36 25 39 14 2 30 5 35 6 4 0 5 -6 2 -15z m-100 -53 c0 -11 -8 -22 -18 -24 -12 -4 -18 1 -18 13 0 10 8 21 18 23 9 3 17 5 17 6 1 0 1 -8 1 -18z m46 -92 c-9 -4 -23 -2 -30 4 -11 9 -11 13 4 24 14 10 19 10 30 -5 10 -14 10 -18 -4 -23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 124 c-13 -20 -14 -29 -5 -38 12 -12 291 -22 347 -11 38 7 44 32 13 60 -18 17 -21 16 -66 -6 -63 -30 -153 -30 -212 0 -52 27 -56 26 -77 -5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkhackLogo);
export default __webpack_public_path__ + "static/media/workhackLogo.c51395985f430fedf97ee9e3c4830ac9.svg";
export { ForwardRef as ReactComponent };